import { Controller } from "@hotwired/stimulus";

// The first screen of the collection menu (treasury plan, L2.2, L2.3): the
// student is found as the cashier types, or by their card. A USB scanner
// types the card's link like a keyboard; the webcam reads the same link.
// A card opens the student's sheet at once, never the link itself.
const CARD = /\/students\/(\d+)\/qr_info/;

export default class extends Controller {
  static targets = ["input", "reader", "error"];
  static values = { sheetUrl: String, delay: { type: Number, default: 250 }, cameraError: String };

  disconnect() {
    clearTimeout(this.timeout);
    this.stopCamera();
  }

  type() {
    clearTimeout(this.timeout);
    if (this.openCard(this.inputTarget.value)) return;

    this.timeout = setTimeout(() => this.element.requestSubmit(), this.delayValue);
  }

  submit(event) {
    if (this.openCard(this.inputTarget.value)) event.preventDefault();
  }

  async scan() {
    if (this.scanner) return this.stopCamera();

    const { Html5Qrcode } = await import("html5-qrcode");
    this.readerTarget.hidden = false;
    this.scanner = new Html5Qrcode(this.readerTarget.id);
    this.scanner
      .start({ facingMode: "environment" }, { fps: 10, qrbox: { width: 240, height: 240 } },
        (text) => this.openCard(text), () => {})
      .catch(() => {
        this.errorTarget.textContent = this.cameraErrorValue;
        this.stopCamera();
      });
  }

  openCard(text) {
    const match = String(text).match(CARD);
    if (!match) return false;

    this.stopCamera();
    window.Turbo.visit(this.sheetUrlValue.replace("__ID__", match[1]));
    return true;
  }

  stopCamera() {
    if (!this.scanner) return;

    const scanner = this.scanner;
    this.scanner = null;
    this.readerTarget.hidden = true;
    scanner.stop().then(() => scanner.clear()).catch(() => {});
  }
}
